import React from 'react';

import DualTime from '@/ui/components/DualTime';
import Heading from '@/ui/components/Heading';

import type { Props } from './types';

const AchievementCard = ({ achievement }: Props) => {
  const { earned_at, title, asset_url } = achievement;

  return (
    <div
      className={`relative p-4 rounded-lg shadow-md flex flex-col items-start ${
        earned_at ? 'bg-white' : 'bg-gray-200'
      }`}>
      <div className="flex items-center w-full">
        {asset_url && (
          <img src={asset_url} alt={title} className="w-12 h-12 mr-4 rounded-full object-cover" />
        )}
        <div>
          <Heading className="text-lg font-bold">{title}</Heading>
          <p>
            {earned_at ? (
              <>
                Earned at: <DualTime dateTime={new Date(earned_at ?? '')} />
              </>
            ) : (
              'Not yet earned'
            )}
          </p>
        </div>
      </div>
    </div>
  );
};
export default React.memo(AchievementCard);
